import axios from 'axios'
// eslint-disable-next-line no-unused-vars
import { useSelector } from 'react-redux'

axios.defaults.baseURL = process.env.REACT_APP_URL

axios.interceptors.request.use(function (config:any) {
  // Do something before request is sent
  config.headers.post['Content-Type'] = 'application/json'
  config.headers.common.Accept = 'application/json'
  // config.headers.post['Access-Control-Allow-Origin'] = '*'

  const userObject = localStorage.getItem('__session_polac_physical')
  if (userObject !== null) { config.headers.common.Authorization = 'Bearer ' + JSON.parse(userObject)?.token }

  return config
}, function (error) {
  // Do something with request error
  return Promise.reject(error)
})
axios.interceptors.response.use(function (config:any) {
  config.headers['cache-control'] = 'no-cache, no-store, must-revalidate'
  return config
}, function (error) {
  // Do something with request error
  return Promise.reject(error)
})
const admissionId = localStorage.getItem('admissionId')
// const result = admissionId()
// console.log('ADD', admissionId)
const userService = {

  getDataAx: async (ref:string) => {
    return await axios.get(`/query-nin-status?nin=${ref}`)
  },
  getDataSingle: async (ref:string|undefined) => {
    return await axios.get(`/subadmin/pscreen/query?nin=${ref}&admissionId=${admissionId}`)
  },
  getImagesList: async (ref:string|undefined) => {
    return await axios.get(`/cpanel/view-credentials?action=list&nin=${ref}&workflow=formSubmission&admissionId=${admissionId}`)
  },
  getImages: async (photo: any, ref:string|undefined) => {
    console.log('print photo:', photo)
    return await axios.get(`/cpanel/view-credentials?nin=${ref}&action=view&workflow=formSubmission&admissionId=${admissionId}&documentType=${photo}`)
    // return await axios.get('/cpanel/view-credentials?nin=69081355236&action=view&admissionId=2&document=birthcertificate-9355372f5f61802bc9cb789be394b2e4.jpg ')
  },
  getImagesSS: async (ssce: any, ref:string|undefined) => {
    console.log('waoaoaodshfsdjfaoa', ssce)
    return await axios.get(`/cpanel/view-credentials?nin=${ref}&action=view&workflow=formSubmission&admissionId=${admissionId}&documentType=${ssce || 'ssce'}`)
  },
  getIndigine: async (indig: any, ref:string|undefined) => {
    return await axios.get(`/cpanel/view-credentials?nin=${ref}&action=view&workflow=formSubmission&admissionId=${admissionId}&documentType=${indig || 'indigneCerificate'}`)
  },
  getbirthCert: async (birth: any, ref:string|undefined) => {
    return await axios.get(`/cpanel/view-credentials?nin=${ref}&action=view&workflow=formSubmission&admissionId=${admissionId}&documentType=${birth || 'birthCertificate'}`)
  },
  updateApplicantData: async (data:any) => {
    return await axios.post('/save-nin-status', data)
  },

  getDocuments: async (nin:string) => {
    return await axios.get(`/cpanel/view-credentials?nin=${nin}&action=list`)
  },
  getDownloadLink: async (nin: any, myDocs: any) => {
    return await axios.get(`cpanel/view-credentials?nin=${nin}&action=view&document=${myDocs}`)
  },
  uploadDocument: async (payload: any) => {
    return await axios.post(`/recruitment/receive-upload-credentials?admissionId=${admissionId}`, payload)
  }

}

export default userService
